// extracted by mini-css-extract-plugin
module.exports = {"ticket":"styles_ticket__ZbHRB","ticket__image":"styles_ticket__image__KoIUY","ticket__amount":"styles_ticket__amount__CMkLf"};